module.exports = __webpack_public_path__ + "media/my_images/footer-5423e97a4d6450dd91a70696f4a8dfd3.jpg";